import React, { useEffect, useState } from 'react'
import { isEmpty } from 'lodash-es'
import { Button, ButtonGroup, ButtonToolbar, IconButton } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'

export default function SubProjectViewFilesWidget({
  files = [],
  stringFilesIsNull = null,
  buttonEye = false,
  buttonDownload = false,
  buttonTrash = false,
  onPreviewFile = () => {},
  onDownloadFile = () => {},
  onDeleteFile = () => {},
  defaultName = null,
}) {
  const [filesList, setFilesList] = useState([])
  useEffect(() => {
    if (files) {
      setFilesList(files)
      // console.log('files2===>', files)
    }
  }, [files])
  return (
    <table width={'100%'} border={1}>
      <tr>
        <th style={{ width: '10%' }}>
          <div style={{ padding: 5 }}>ลำดับ</div>
        </th>
        <th style={{ width: '70%' }}>
          <div style={{ padding: 5 }}>ชื่อไฟล์</div>
        </th>
        <th style={{ width: '20%' }}>#</th>
      </tr>
      {filesList.length <= 0 ? (
        <tr>
          <td colspan="3">
            <div style={{ padding: 5, textAlign: 'center' }}>
              {stringFilesIsNull ? stringFilesIsNull : 'ไม่พบไฟล์...'}
            </div>
          </td>
        </tr>
      ) : (
        <>
          {filesList.map((item, index) => {
            return (
              <tr>
                <td>
                  <div style={{ padding: 5, textAlign: 'center' }}>{index + 1}</div>
                </td>
                <td>
                  {!defaultName ? (
                    <div style={{ padding: 5 }}>{item.name || item.path}</div>
                  ) : (
                    <div style={{ padding: 5 }}>{defaultName}</div>
                  )}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <div style={{ padding: 5 }}>
                    <ButtonToolbar>
                      <ButtonGroup>
                        {buttonEye && (
                          <TooltipButton
                            icon="eye"
                            tooltip={`แสดง`}
                            onClick={(_) => onPreviewFile(item)}
                          />
                        )}

                        {buttonDownload && (
                          <TooltipButton
                            icon="download"
                            tooltip={`ดาวน์โหลด`}
                            onClick={(_) => onDownloadFile(item)}
                          />
                        )}

                        {buttonTrash && (
                          <TooltipButton
                            icon="trash-o"
                            tooltip={`ลบ`}
                            onClick={(_) => onDeleteFile(item)}
                          />
                        )}
                      </ButtonGroup>
                    </ButtonToolbar>
                  </div>
                </td>
              </tr>
            )
          })}
        </>
      )}
    </table>
  )
}
